import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.setTimeout(() => {
      window.location.reload();
    }, 2000);
  }
}
